import React, {useState} from "react";
import MuiPopper from "@mui/material/Popper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import "./tabletToolbarGroup.scss";

type TabletToolbarGroupProps = {
	trigger: React.ReactElement
	children: React.ReactNode
	disabled?: boolean
}

export function TabletToolbarGroup({trigger, children, disabled}: TabletToolbarGroupProps) {
	const [open, setOpen] = useState(false)
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

	const handleTriggerClick = () => {
		if (!disabled) {
			setOpen(prev => !prev)
		}
	}

	const handleClickAway = (event: MouseEvent | TouchEvent) => {
		if (anchorEl?.contains(event.target as Node)) {
			return
		}
		setOpen(false)
	}

	return (
		<>
			<div ref={setAnchorEl} onClick={handleTriggerClick}>
				<div className="tablet-toolbar-group_trigger-wrapper">
					{trigger}
					<div className={`tablet-toolbar-group_chevron${open ? " tablet-toolbar-group_chevron--open" : ""}`}>
						<svg width="8" height="5" viewBox="0 0 8 5" fill="currentColor" aria-hidden="true">
							<path d="M0 0l4 5 4-5z"/>
						</svg>
					</div>
				</div>
			</div>
			<MuiPopper open={open} anchorEl={anchorEl}>
				<ClickAwayListener onClickAway={handleClickAway}>
					<div>
						<div className="tablet-toolbar-group" onClick={() => setOpen(false)}>
							{children}
						</div>
					</div>
				</ClickAwayListener>
			</MuiPopper>
		</>
	)
}
